import React, { Fragment, useState } from "react";
import styled from "styled-components";
import FieldGroup from "../../interfaces/FieldGroup";
import FieldSelectionMap from "../../interfaces/FieldSelectionMap";
import FieldOption from "./FieldOption";
import {
  Icon as UnstyledIcon,
  Checkbox as UnstyledCheckbox,
  List as UnstyledList,
  Collapse,
  ListItem,
} from "@material-ui/core";

const List = styled(UnstyledList)`
  && {
    padding-left: 38px;

    & > li {
      padding: 6px 0;
      user-select: none;
    }
  }
`;

const Button = styled.button`
  all: unset;
  cursor: pointer;
`;

const Icon = styled(UnstyledIcon)`
  display: block;
`;

const Label = styled.label`
  && {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    white-space: break-spaces;
    font-size: 16px;
  }
`;

const Checkbox = styled(UnstyledCheckbox)`
  && {
    width: 23px;
    height: 23px;
    margin-right: 6px;
  }
`;

interface FieldGroupOptionProps {
  fieldGroup: FieldGroup;
  fieldSelectionMap: FieldSelectionMap;
  setFieldSelectionMap: (map: FieldSelectionMap) => void;
}

const FieldGroupOption = (props: FieldGroupOptionProps) => {
  const { fieldGroup, fieldSelectionMap, setFieldSelectionMap } = props;
  const [isOpen, setIsOpen] = useState(false);

  const isChecked = fieldGroup.fields.every(
    (field) => fieldSelectionMap[field.fieldId]
  );
  const isIndeterminate =
    !isChecked &&
    fieldGroup.fields.some((field) => fieldSelectionMap[field.fieldId]);

  const toogleField = () => {
    const newMap = Object.assign({}, fieldSelectionMap);

    if (!isChecked || isIndeterminate) {
      fieldGroup.fields.forEach((field) => {
        newMap[field.fieldId] = true;
      });
    } else {
      fieldGroup.fields.forEach((field) => {
        newMap[field.fieldId] = false;
      });
    }

    setFieldSelectionMap(newMap);
  };

  return (
    <Fragment>
      <ListItem>
        <Button onClick={() => setIsOpen((open) => !open)}>
          <Icon>{`arrow_${isOpen ? "drop_down" : "right"}`}</Icon>
        </Button>
        <Label>
          <Checkbox
            color="primary"
            checked={isChecked || isIndeterminate}
            indeterminate={isIndeterminate}
            onChange={toogleField}
          />
          <span>{fieldGroup.name}</span>
        </Label>
      </ListItem>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List disablePadding>
          {fieldGroup.fields.map((field) => (
            <FieldOption
              key={field.fieldId}
              field={field}
              fieldSelectionMap={fieldSelectionMap}
              setFieldSelectionMap={setFieldSelectionMap}
            />
          ))}
        </List>
      </Collapse>
    </Fragment>
  );
};

export default FieldGroupOption;
